import { render } from "./Main.vue?vue&type=template&id=5be904c6"
import script from "./Main.vue?vue&type=script&setup=true&lang=js"
export * from "./Main.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Pathways/Main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5be904c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5be904c6', __exports__)) {
    api.reload('5be904c6', __exports__)
  }
  
  module.hot.accept("./Main.vue?vue&type=template&id=5be904c6", () => {
    api.rerender('5be904c6', render)
  })

}


export default __exports__